// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_3jJF-YY","transitionList__element":"_7A5raQ3","transitionList__overlay":"_5za5cGj","transitionList__element--exiting":"_33JlLjK","transitionList_itemDeletedLabel":"_1iNwCvT","scaler":"_14Vh9ji"};


//////////////////
// WEBPACK FOOTER
// ./template/components/TransitionList/index.css
// module id = ./template/components/TransitionList/index.css
// module chunks = client.sitechrome